import React from "react";
import { Link } from "react-router-dom";

const LandingByHours = () => {
  const oneToFive = "10:13 pm on February 3, 2025";
  const fiveToTen = "8:38 pm on February 4, 2025";
  const tenToFifteen = "10:13 pm on February 3, 2025";
  const fifteenToTwenty = "10:13 pm on February 3, 2025";

  return (
    <div className="container" style={{ maxWidth: "100%" }}>

      {/* Card for 1-5 hours */}
      <div className="card mb-3 mt-4">
        <div className="row g-0">
          <div className="col-md-4 d-flex align-items-center justify-content-center">
            <h3>1-5 hours</h3>
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <Link type="button" className="btn btn-success mx-2" to="/d372">
                D372
              </Link>
              <Link type="button" className="btn btn-success mx-2" to="/d197">
                D197
              </Link>
              <Link type="button" className="btn btn-success mx-2" to="/d370">
                D370
              </Link>
              <Link type="button" className="btn btn-success mx-2" to="/d333">
                D333
              </Link>
              <Link type="button" className="btn btn-success mx-2" to="/d386">
                D386
              </Link>
              <Link type="button" className="btn btn-success mx-2" to="/d284">
                D284
              </Link>
              <Link type="button" className="btn btn-success mx-2" to="/d480">
                D480
              </Link>
              <Link type="button" className="btn btn-success mx-2" to="/d387">
                D387
              </Link>

              <p className="card-text">
                <small className="text-body-secondary">
                  Last updated at {oneToFive}
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Card for 5-10 hours */}
      <div className="card mb-3">
        <div className="row g-0">
          <div className="col-md-4 d-flex align-items-center justify-content-center">
            <h3>5-10 hours</h3>
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <Link type="button" className="btn btn-info mx-2" to="/d277">
                D277
              </Link>
              <Link type="button" className="btn btn-info mx-2" to="/d315">
                D315
              </Link>
              <Link type="button" className="btn btn-info mx-2" to="/d279">
                D279
              </Link>
              <Link type="button" className="btn btn-info mx-2" to="/d336">
                D336
              </Link>
              <Link type="button" className="btn btn-info mx-2" to="/d426">
                D426
              </Link>
              <Link type="button" className="btn btn-info mx-2" to="/d427">
                D427
              </Link>
              <Link type="button" className="btn btn-info mx-2" to="/d326">
                D326
              </Link>
              <Link type="button" className="btn btn-info mx-2" to="/c949">
                C949
              </Link>
              <Link type="button" className="btn btn-info mx-2" to="/d385">
                D385
              </Link>
              <Link type="button" className="btn btn-info mx-2" to="/d479">
                D479
              </Link>

              <p className="card-text">
                <small className="text-body-secondary">
                  Last updated at {fiveToTen}
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Card for 10-15 hours */}
      <div className="card mb-3">
        <div className="row g-0">
          <div className="col-md-4 d-flex align-items-center justify-content-center">
            <h3>10-15 hours</h3>
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <Link type="button" className="btn btn-warning mx-2" to="/d278">
                D278
              </Link>
              <Link type="button" className="btn btn-warning mx-2" to="/d276">
                D276
              </Link>
              <Link type="button" className="btn btn-warning mx-2" to="/d287">
                D287
              </Link>
              <Link type="button" className="btn btn-warning mx-2" to="/d288">
                D288
              </Link>
              <Link type="button" className="btn btn-warning mx-2" to="/d424">
                D424
              </Link>

              <p className="card-text">
                <small className="text-body-secondary">
                  Last updated at {tenToFifteen}
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Card for 15-20 hours */}
      <div className="card mb-3">
        <div className="row g-0">
          <div className="col-md-4 d-flex align-items-center justify-content-center">
            <h3>15-20 hours</h3>
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <Link type="button" className="btn btn-danger mx-2" to="/d280">
                D280
              </Link>
              <Link type="button" className="btn btn-danger mx-2" to="/d282">
                D282
              </Link>
              <Link type="button" className="btn btn-danger mx-2" to="/d308">
                D308
              </Link>

              <p className="card-text">
                <small className="text-body-secondary">
                  Last updated at {fifteenToTwenty}
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingByHours;
